
export type Intersections = number;
export let Intersections: any = {};
Intersections.NO_INTERSECT = 0;
Intersections.COLLINEAR = 1;
Intersections.INTERSECT = 2;
Intersections[Intersections.NO_INTERSECT] = "NO_INTERSECT";
Intersections[Intersections.COLLINEAR] = "COLLINEAR";
Intersections[Intersections.INTERSECT] = "INTERSECT";
